<template>
  <div class="page-header">
    <div class="row justify-content-between">
      <div class="col-auto p-0">
        <b-nav>
          <b-nav-item v-for="(linkObj, linkTitle) in $route.meta.breadcrumbObject" :key="linkTitle">
            <router-link :to="linkObj">
              {{linkTitle}}
            </router-link>
            <span>/</span>
          </b-nav-item>
          <b-nav-item v-for="linkObj in breadcrumbs">
            <router-link :to="linkObj">
              {{linkObj.text}}
            </router-link>
            <span>/</span>
          </b-nav-item>
        </b-nav>
      </div>
      <div class="col link" v-if="linkText">
        <router-link :to="{name: routeName}">{{linkText}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'header-breadcrumbs',
    data: function () {
      return {
        breadcrumbs: []
      }
    },
    created () {
      var self = this
      this.$root.$on('changeBreadCrumbs', function (breabcrumbs) {
        self.breadcrumbs = breabcrumbs
      })
    },
    watch: {
      '$route': function (to, from) {
        if (from.matched[0].name !== 'article-page') {
          this.breadcrumbs = []
        }
      }
    },
    destroyed () {
      this.$root.$off('changeBreadCrumbs')
    },
    computed: {
      isArticlePage: function () {
        return this.$route.matched.filter(item => {
          return item.name === 'article-page'
        }).length
      },
      isEditoralBoardPage: function () {
        return this.$route.name === 'editorialBoardMembers' || this.$route.name === 'editorialBoardMemberDetail'
      },
      isHundredPlusPage: function () {
        return this.$route.name === 'hundredPlus'
      },
      isHomePage: function () {
        return this.$route.name === 'Home'
      },
      linkText: function () {
        if (this.isArticlePage) {
          return 'View Current Issue >'
        } else if (this.isEditoralBoardPage) {
          return 'View 100+ Papers from the Editorial Board >'
        } else if (this.isHundredPlusPage) {
          return 'View the Editorial Board >'
        } else {
          return 'View Archives >'
        }
      },
      routeName: function () {
        if (this.isArticlePage) {
          return 'currentIssue'
        } else if (this.isEditoralBoardPage) {
          return 'hundredPlus'
        } else if (this.isHundredPlusPage) {
          return 'editorialBoardMembers'
        } else {
          return 'archivedIssues'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .page-header {
    border-top: 1px solid $page-header-border;
    background-color: $page-header-bg;
    padding: 10px 15px;
    margin-bottom: 10px;
    font-family: 'Merriweather';
    font-style: italic;
    font-size: 14px;
    .router-link-active {
      text-decoration: none;
      cursor: default;
    }
    .link {
      text-align: end;
      text-decoration: underline;
      line-height: 40px;
    }
    span {
      padding: 0.5em 0 0.5em 1em;
    }
  }
</style>



// WEBPACK FOOTER //
// HeaderBreadcrumbsComponent.vue?b7ac84dc